import React from 'react';
import Spinner from './Spinner';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  fullWidth?: boolean;
  loading?: boolean;
}

export default function Button({
  children,
  size = 'md',
  variant = 'primary',
  fullWidth = false,
  loading = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseClasses =
    'inline-flex items-center justify-center font-semibold tracking-tight rounded-2xl transition-all duration-150 active:scale-95 disabled:opacity-50 disabled:active:scale-100 disabled:cursor-not-allowed gap-2';

  const sizeClasses = {
    sm: 'text-xs px-4 py-2',
    md: 'text-sm px-6 py-3',
    lg: 'text-base px-8 py-4',
  };

  const variantClasses = {
    primary:
      'bg-brand-primary text-white hover:bg-brand-primary-dark shadow-lg shadow-brand-primary/10',
    secondary:
      'bg-brand-secondary text-white hover:bg-brand-secondary-dark shadow-lg shadow-brand-secondary/10',
    outline: 'bg-white border-2 border-brand-border text-brand-text hover:bg-brand-bg',
    ghost: 'text-brand-text hover:bg-brand-bg',
  };

  return (
    <button
      disabled={disabled || loading}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </button>
  );
}
